// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"21078565","5":"5219a9bd","159":"1cddf72a","390":"033d6ee6","488":"7956be2c","504":"90821582","534":"4ba961f4","562":"63d9b166","726":"027f40bb","730":"ed0c1b9a","957":"88ad2ff2"}[chunkId] + ".chunk.js";
};